import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

import { Link } from 'react-router-dom';
import { TranslationContext } from "../hooks/useTranslationContext";

export const ReportingPageTabs = (props) => {
    const t = useContext(TranslationContext);
    return (
        <ul className="tab tab-block reportingpage">
            <li className={"tab-item" + (props.location?.pathname ==="/reporting" ? " active" : "")}>
                <Link to="/reporting">{"Reports"}</Link>
            </li>
            <li className={"tab-item" + (props.location?.pathname ==="/reporting-firmware" ? " active" : "")}>
                <Link to="/reporting-firmware">{t('reporting.firmware_report')}</Link>
            </li>
            <li className={"tab-item" + (props.location?.pathname ==="/reporting-pue" ? " active" : "")}>
                <Link to="/reporting-pue">{t('pue.title')}</Link>
            </li>
            <li className={"tab-item" + (props.location?.pathname ==="/reporting-events" ? " active" : "")}>
                <Link to="/reporting-events">{t('reporting.event_report')}</Link>
            </li>
            <li className={"tab-item" + (props.location?.pathname ==="/reporting-backups" ? " active" : "")}>
                <Link to="/reporting-backups">{t('reporting.backup_report')}</Link>
            </li>
        </ul>
    );
};

ReportingPageTabs.contextTypes = {
    t: PropTypes.func
};

ReportingPageTabs.propTypes = {
    location: ReactRouterPropTypes.location
};
